import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import HomepageFeatureZone from "./homepageFeatureZone";
import PageTitle from "../../utils/pageTitle";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import BuilderIOSection from "../../builderio/components/builderIOSection";
import { BuilderIOSections } from "../../models/constants";
import dataService from "../../services/dataService";
import HomepageSecondaryUser from "./homepageSecondaryUser";
import { useEffect, useState } from "react";
import { FeaturedCategory } from "../../models/customer/types";
import { useDestinationWarehouseRedirect } from "@/app/hooks/useDestinationWarehouseRedirect";
import tokenProvider from "@/app/auth/tokenProvider";

const Homepage: React.FC = () => {
  PageTitle(null); // Set page title

  const { warehouseName, warehouseCode } = useSelector(
    (state: RootState) => state.warehouseState.selectedWarehouse
  );

  const warehouse = useSelector(
    (state: RootState) => state.warehouseState.selectedWarehouse
  );
  const isWarehouseInfoLoaded = useSelector(
    (state: RootState) => state.warehouseState.isWarehouseInfoLoaded
  );
  const isAuthenticated = useSelector(
    (state: RootState) => state.userState.isAuthenticated
  );
  const isSecondaryUser = useSelector(
    (state: RootState) => state.userState.user.isSecondaryUser
  );

  // Redirect to destination warehouse if specified in destinationWarehouseCode query parameter
  useDestinationWarehouseRedirect(isAuthenticated);

  const impactProgramsUrl =
    window.location.href + "/impact-programs/impact-programs-overview";

  const productTemplatesUrl = isAuthenticated
    ? "/ProductList/Public"
    : process.env.REACT_APP_WEB_URL +
      "/quicklogin?returnUrl=" +
      encodeURIComponent("/ProductList/Public");

  const onlineBillPayVisible = useSelector(
    (state: RootState) => state.userState.user.accountMenu?.onlineBillPayVisible
  );

  const [featuredCategories, setFeaturedCategories] = useState<{
    [key: string]: FeaturedCategory;
  }>({});

  useEffect(() => {
    const fetchFeaturedCategories = async () => {
      const response = await dataService.getFeaturedCategoriesVisibilities(
        warehouse?.warehouseCode ?? "",
        isAuthenticated
      );
      setFeaturedCategories(response.data);
    };

    fetchFeaturedCategories();
  }, [warehouseCode, isAuthenticated]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.get("impersonated") === "1") {
      tokenProvider.clearToken();
      params.delete("impersonated");
      const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : window.location.pathname;

      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  return (
    <>
      {isSecondaryUser && <HomepageSecondaryUser />}
      <HomepageFeatureZone />
      <Container maxWidth="lg">
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          {/* <HomePageCategories /> */}
          {isWarehouseInfoLoaded && (
            <BuilderIOSection
              section={BuilderIOSections.FigmaSection}
              data={{
                warehouse: warehouse.warehouseCode,
                impactProgramsUrl: impactProgramsUrl,
                productTemplatesUrl: productTemplatesUrl,
                onlineBillPayVisible: onlineBillPayVisible ?? false,
                categories: featuredCategories,
              }}
              filter={{
                name: BuilderIOSections.TagFilterName,
                value: BuilderIOSections.FeaturedCategoriesFilterValue,
              }}
            />
          )}
        </Grid>
      </Container>
    </>
  );
};

export default Homepage;
